export default __webpack_public_path__ + "static/media/WaitingCall.9e6c0dda.svg";